import React, { useEffect } from 'react';
import ArrowLeft from '../../Assets/Arrow left.svg';
import { Link, useLocation, useParams } from 'react-router-dom';
import ProfileInfoBar from './Components/Profile/ProfileInfoBar';
import ProfilePostGrid from './Components/Profile/ProfilePostGrid';
import Modal from './Components/Modal/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSellerInfo } from '../../Features/lensSlice';
import Loading from '../../Components/Loading/Loading';
import Error from '../../Components/Error/Error';

function LensProfile() {
    const params = useParams();
    const dispatch = useDispatch();
    const location = useLocation();

    const { sellerInfo, loading } = useSelector((state) => state.lens.sellerInfo);

    const storeData = useSelector((state) => state.lens.storeData.storeData);

    useEffect(() => {
        params.lensId && dispatch(fetchSellerInfo(params.lensId));
        // eslint-disable-next-line
    }, [params.lensId]);

    if(loading === 'loading') {
        return <Loading />
    }

    if(loading === 'failed') {
        return <Error />
    }

    return (
        <div className="w-full overflow-y-scroll pb-16 outline-none">
            <div className="flex items-center justify-between gap-6 relative m-[20px_19px_24px_20px]">
                <div className="w-fit flex items-center">
                    <Link to={`${location.pathname.split('/').slice(0, -2).join('/')}`} className="img p-[10px] flex items-center justify-center">
                        <img className='size-6 text-[#666666]' src={ArrowLeft} alt="" />
                    </Link>

                    <h1 className="p-[6px] select-none text-[#121212] font-bold text-2xl">{storeData.id === sellerInfo.id ? 'Your' : 'User '} Profile</h1>
                </div>
            </div>

            <ProfileInfoBar />

            <ProfilePostGrid />

            <Modal />
        </div>
    );
}

export default LensProfile;
